import { eventPageMatchPath } from '@ms/yammer-web-support/dist/urls';
import { useUIFeatures } from '@ms/yammer-web-ui-features/dist/features';
import { matchPath } from 'react-router';
import { useLocation } from 'react-router-dom';

const pageBlocklist = [eventPageMatchPath];

type UseShouldDisplayCollapsiblePanelForCurrentPage = () => boolean;
export const useShouldDisplayCollapsiblePanelForCurrentPage: UseShouldDisplayCollapsiblePanelForCurrentPage = () => {
  const isCollapsiblePanelEnabled = useUIFeatures((features) => features.navigation?.collapsiblePanel ?? false);
  const { pathname } = useLocation();

  return isCollapsiblePanelEnabled && !pageBlocklist.some((pagePath) => matchPath(pathname, { path: pagePath }));
};
